import React from 'react';
import LegalLayout, { Section } from '../components/LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms Of Service" effectiveDate="August 28, 2026">
    <Section title="">
      <p>
        These Terms Of Service ("Terms") Govern Access To And Use Of Services Provided By YOVAI LLC ("YOVAI," "We," "Our," Or "Us").
      </p>
      <p>
        By Purchasing, Accessing, Or Using YOVAI Services, The Customer ("Client," "You," Or "Your") Agrees To These Terms.
      </p>
    </Section>

    <Section title="1. Services">
      <p>YOVAI Provides AI-Powered Business Communication And Automation Solutions.</p>
      <p>
        Services May Include AI Receptionist Services, Inbound Call Handling, Appointment Scheduling, Lead Capture, SMS Communications, Automated Follow-Up, Workflow Automation, Call Routing, Reporting, Integrations, Implementation, And Related Support Services.
      </p>
      <p>
        Specific Features And Functionality May Vary According To The Client's Selected Service Package, Configuration, Integrations, And Third-Party Platforms.
      </p>
    </Section>

    <Section title="2. Professional Implementation">
      <p>YOVAI Services May Require A One-Time Professional Implementation (Setup) Fee.</p>
      <p>
        Service Fees, Implementation Costs, Billing Schedules, And Ongoing Support Arrangements Are Defined In Each Client's Approved Proposal And Service Agreement.
      </p>
      <p>
        Implementation May Include AI Agent Configuration, Voice And Persona Configuration, Business Information Setup, Knowledge Base Configuration, Calendar And Scheduling Integration, Communication Workflows, Automations, Testing, Integrations, And Launch Preparation.
      </p>
      <p>The Professional Implementation Fee Is Separate From The Client's Recurring Subscription Fee.</p>
      <p>
        Because Implementation Involves Customized Work Performed For The Client, The Implementation Fee Is Generally Non-Refundable Once Implementation Work Has Begun, Except Where Required By Applicable Law Or Otherwise Agreed To By YOVAI In Writing.
      </p>
    </Section>

    <Section title="3. Subscriptions And Recurring Billing">
      <p>YOVAI Offers Recurring Subscription Services.</p>
      <p>Current Service Packages Include Lead Recovery, Booking Growth, And Multi-Location Operations.</p>
      <p>Service Fees, Implementation Costs, Billing Schedules, And Ongoing Support Arrangements Are Defined In Each Client's Approved Proposal And Service Agreement.</p>
      <p>
        By Purchasing A Recurring Subscription, The Client Authorizes YOVAI And Its Payment Processor To Charge The Payment Method Provided For The Initial Payment, Recurring Subscription Fees, And Other Charges Specifically Authorized By The Client.
      </p>
      <p>
        Subscriptions Automatically Renew At The Applicable Billing Interval Until Canceled In Accordance With These Terms And Any Applicable Client Agreement.
      </p>
    </Section>

    <Section title="4. Initial Payment And Package Pricing">
      <p>Service Fees, Implementation Costs, Billing Schedules, And Ongoing Support Arrangements Are Defined In Each Client's Approved Proposal And Service Agreement.</p>
      <p>Testing Confirms The Agreed Functionality; It Does Not Guarantee Bookings, Revenue, Or Other Business Results.</p>
      <p>Prices May Change For Future Purchases.</p>
      <p>
        If Pricing Displayed At Checkout Or In A Signed Client Agreement Differs From Pricing Listed In These Terms, The Checkout Or Signed Agreement Shall Control.
      </p>
    </Section>

    <Section title="5. Automatic Renewal">
      <p>Recurring YOVAI Subscriptions Automatically Renew According To The Billing Frequency Selected At Checkout Unless Canceled.</p>
    </Section>

    <Section title="6. Cancellation">
      <p>Clients May Request Cancellation Using YOVAI's Published Contact Information.</p>
      <p>Cancellation Prevents Future Subscription Renewals But Does Not Retroactively Cancel Charges Already Incurred.</p>
    </Section>

    <Section title="7. Refunds">
      <p>
        Professional Implementation Fees Are Generally Non-Refundable Once Implementation Work Has Begun, Except Where Required By Applicable Law Or Otherwise Agreed To By YOVAI In Writing.
      </p>
      <p>
        Recurring Subscription Charges For Service Periods That Have Already Begun Are Generally Non-Refundable Except Where Required By Applicable Law Or Expressly Approved By YOVAI.
      </p>
    </Section>

    <Section title="8. AI And Automation Disclosure">
      <p>
        YOVAI Services May Use Artificial Intelligence And Automated Systems To Communicate With Callers, Leads, Customers, Patients, Prospects, Or Other Individuals On Behalf Of A Client.
      </p>
      <p>
        AI Systems May Occasionally Misunderstand Requests, Generate Incorrect Information, Experience Technical Interruptions, Or Produce Unexpected Results.
      </p>
      <p>YOVAI Does Not Guarantee That AI Systems Will Be Error-Free Or Uninterrupted.</p>
    </Section>

    <Section title="9. No Guaranteed Business Results">
      <p>
        YOVAI Does Not Guarantee Any Specific Number Of Leads, Appointments, Customers, Sales, Revenue, Cost Savings, Conversion Rates, Or Other Business Results.
      </p>
    </Section>

    <Section title="10. Client Responsibilities">
      <p>Clients Are Responsible For Providing Accurate And Current Business Information Necessary To Configure Their YOVAI System.</p>
    </Section>

    <Section title="11. Communications And Compliance">
      <p>
        Clients Are Responsible For Ensuring Their Use Of YOVAI Services Complies With Applicable Telephone, SMS, Marketing, Recording, Privacy, Data Protection, And Industry-Specific Requirements.
      </p>
    </Section>

    <Section title="12. Third-Party Services">
      <p>
        YOVAI May Depend Upon Third-Party Providers For Telecommunications, Artificial Intelligence, Messaging, Scheduling, Payment Processing, Hosting, Analytics, Integrations, And Other Functionality.
      </p>
    </Section>

    <Section title="13. Service Availability">
      <p>
        References To "24/7" Describe Intended Availability And Do Not Constitute A Guarantee Of Completely Uninterrupted Service.
      </p>
    </Section>

    <Section title="14. Acceptable Use">
      <p>
        Clients May Not Use YOVAI Services For Unlawful, Fraudulent, Deceptive, Abusive, Harassing, Or Otherwise Prohibited Activities.
      </p>
    </Section>

    <Section title="15. Intellectual Property">
      <p>
        YOVAI Retains Ownership Of Its Proprietary Systems, Workflows, Methodologies, Templates, Branding, Configurations, Processes, And Other Intellectual Property.
      </p>
    </Section>

    <Section title="16. Limitation Of Liability">
      <p>
        To The Maximum Extent Permitted By Applicable Law, YOVAI Will Not Be Liable For Indirect, Incidental, Special, Consequential, Exemplary, Or Punitive Damages.
      </p>
    </Section>

    <Section title="17. Termination">
      <p>
        YOVAI May Suspend Or Terminate Access To Services For Material Violations Of These Terms, Fraudulent Or Unlawful Activity, Nonpayment, Abuse Of Services, Security Risks, Or Other Circumstances Reasonably Requiring Suspension Or Termination.
      </p>
    </Section>

    <Section title="18. Changes To Services Or Terms">
      <p>YOVAI May Update These Terms Periodically.</p>
    </Section>

    <Section title="19. Governing Law">
      <p>
        These Terms Are Governed By The Laws Of The State Of Georgia, Except Where Applicable Law Requires Otherwise.
      </p>
    </Section>
  </LegalLayout>
);

export default Terms;
